import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "auto", fontFamily: "Arial", marginTop:"25px" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> April 2026</p>

      <p>
        This Privacy Policy explains how we collect, use, and protect your information when you interact
        with us via our website and WhatsApp.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name</li>
        <li>Phone number</li>
        <li>WhatsApp messages</li>
        <li>Information you provide voluntarily</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Customer support via WhatsApp</li>
        <li>Send updates and notifications</li>
        <li>Improve services</li>
      </ul>

      <h2>3. WhatsApp Communication</h2>
      <p>
        By contacting us via WhatsApp, you consent to receive messages from us. We use WhatsApp services
        provided by Meta Platforms.
      </p>

      <h2>4. Data Sharing</h2>
      <p>
        We do not sell your personal data. Data is shared only when required by law.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable steps to protect your data.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You can request to access or delete your data or stop receiving messages anytime.
      </p>

      <h2>7. Contact Us</h2>
      <p>Email: your-email@example.com</p>
    </div>
  );
};

export default PrivacyPolicy;